import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, EmptyState, RowsSkeletonLoader } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { usePaymentCaseContext } from 'hooks/context/usePaymentCaseContext'
import { usePaymentCaseDocumentsQuery } from 'hooks/queries/usePaymentCaseDocumentsQuery'
import { PaymentCaseDocument } from './PaymentCaseDocument'
import { PaymentCaseError } from './PaymentCaseError'

export const PaymentCaseDocuments = () => {
  const { t } = useTranslation()

  const { paymentCaseId } = usePaymentCaseContext()

  const {
    data: { files: paymentCaseDocuments } = {},
    isPending,
    isError,
  } = usePaymentCaseDocumentsQuery(paymentCaseId)

  return (
    <Box>
      {isPending && <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />}
      <Box paddingX={20}>
        {isError && !isPending && (
          <EmptyState
            testId="error-state"
            LottiePlayer={<Lottie src="connection-error" />}
            title={t('paymentSupport.errorHeadline')}
            description={<PaymentCaseError />}
          />
        )}

        {!isPending && !isError && !!paymentCaseDocuments?.length && (
          <Box flexCol gapY={16}>
            <h4 className="text-h4 text-foreground-prominent">
              {t('paymentSupport.uploadedDocuments')}
            </h4>
            <Box flexCol gapY={24}>
              {paymentCaseDocuments?.map((paymentCaseDocument, paymentCaseDocumentIndex) => (
                <PaymentCaseDocument
                  testId={`payment-case-document-${paymentCaseDocument?.id}`}
                  key={paymentCaseDocumentIndex}
                  paymentCaseDocument={paymentCaseDocument}
                />
              ))}
            </Box>
          </Box>
        )}

        {!isPending && !isError && !paymentCaseDocuments?.length && (
          <EmptyState
            testId="empty-state"
            LottiePlayer={<Lottie src="no-data" />}
            title={t('paymentSupport.noCaseDocuments')}
          />
        )}
      </Box>
    </Box>
  )
}
